@import '../../sass/base/variables';
/* som-popover */

.som-button-dropdown {
  .som-popover-container {
    min-width: 10rem;
    max-width: 17.5rem;
  }
}

.som-popover-container {
  position: absolute !important;
  -webkit-box-shadow: 0 0 10px 0 rgba($black, 0.25);
  -moz-box-shadow: 0 0 10px 0 rgba($black, 0.25);
  box-shadow: 0 0 10px 0 rgba($black, 0.25);
  // border-radius: 4px;
  z-index: 10;
  background-color: $white;

  &.som-popover-hidden {
    display: none;
  }

  .som-popover-content {
    display: block;
  }
}
